/**
 * Small, UI-free helpers for the Campaigns page — kept out of the .jsx so they
 * can be tested with plain Node (see scripts/campaigns.test.mjs).
 */
import { apiErrorMessage, apiErrorCode } from './apiError.js';

/** Shown when no customer matches the audience filters (backend: EMPTY_SEGMENT). */
export const EMPTY_AUDIENCE_MSG =
  'No customers match this campaign’s audience. Adjust the audience filters '
  + '(status, minimum score, lead source, last activity) or add matching customers, then try again.';

/**
 * A readable launch/preview/create error. The server's own message is used
 * (apiErrorMessage unwraps the response body — err.message alone is just
 * "Request failed with status code 400"); EMPTY_SEGMENT gets plain guidance.
 */
export const campaignErrorMessage = (err) =>
  (apiErrorCode(err) === 'EMPTY_SEGMENT'
    ? EMPTY_AUDIENCE_MSG
    : apiErrorMessage(err, 'unknown error'));

/**
 * Index of the first campaign step with no message text, or -1 when every step
 * has some. A step with neither a template nor a body cannot be launched
 * (backend: STEP_CONTENT_MISSING), so the wizard refuses to save it.
 */
export const firstEmptyStep = (cadence) =>
  (cadence || []).findIndex((s) => !String(s?.bodyOverride || '').trim());

/**
 * True when the audience preview came back with nobody in it — the launch would
 * be refused (EMPTY_SEGMENT). A missing/failed preview is NOT "empty".
 */
export const isEmptyAudience = (preview) =>
  preview != null && Number(preview.count) === 0;
